/**
 * GridLinks Functional Component
 * @Package - seo/make
 * @Author - Cybage@UPWA-Team
 * @description: Models related to make SEO
 */
/**
 *  Make SEO's GridLinks Component
 */
import React, { useMemo } from 'react'
import { useResponsiveWrapperContext } from '@usap/uicomponents'

import SeoGridLinks from '../seo/SeoGridLinks'
import { pageTypes } from '../../helpers/PageTypeIdentifier'

export default function GridLinks({ layoutParams, dynamicApiData }) {
  const { isDesktop } = useResponsiveWrapperContext()

  const parts = useMemo(
    () => dynamicApiData && dynamicApiData.shopByParts,
    [dynamicApiData],
  )

  const hasParts = useMemo(
    () => Boolean(parts && Object.keys(parts).length),
    [parts],
  )

  const data = useMemo(
    () => hasParts && parts.map(obj => obj),
    [hasParts, parts],
  )

  const headings = useMemo(
    () => dynamicApiData && dynamicApiData.headings,
    [dynamicApiData],
  )
  const title = useMemo(
    () => headings && headings.shopByParts,
    [headings],
  )

  const colWidth = isDesktop ? '25%' : '50%'

  if (!hasParts) return ''

  return (
    <SeoGridLinks
      id="VlpGridLinks"
      data={data}
      title={title}
      colWidth={colWidth}
      showMoreLimit={layoutParams?.maxDesktopDisplay}
      pageType={pageTypes.YMMP}
    />
  )
}
